import { z } from 'zod'

export const currentYear = new Date().getFullYear()

export const studentSearchSchema = z.object({
  query: z.string().optional(),
  eventId: z.string().optional(),
  eventCutoff: z.number().positive().optional(),
  graduationYear: z
    .number()
    .int()
    .min(currentYear)
    .max(currentYear + 6)
    .optional(),
  minGPA: z.number().min(0).max(4.0).optional(),
  minSatScore: z.number().int().min(400).max(1600).optional(),
  includeMissingSatScore: z.boolean().optional(),
  minActScore: z.number().int().min(1).max(36).optional(),
  includeMissingActScore: z.boolean().optional(),
  state: z.string().length(2).optional(),
  competitionTeam: z.enum(['men', 'women']).optional(),
  genderIdentity: z.string().optional(),
  division: z.string().optional(),
  page: z.number().int().min(1).default(1),
  limit: z.number().int().min(1).max(100).default(20),
  sortBy: z
    .enum([
      'name',
      'graduationYear',
      'gpa',
      'satScore',
      'actScore',
      'personalRecord',
      'competitionTeam',
      'createdAt',
    ])
    .default('createdAt'),
  sortOrder: z.enum(['asc', 'desc']).default('desc'),
})

export const createCheckoutSessionSchema = z.object({
  successUrl: z.string().url('Invalid success URL'),
  cancelUrl: z.string().url('Invalid cancel URL'),
})

export const createStudentCheckoutSchema = z.object({
  successUrl: z.string().url('Invalid success URL'),
  cancelUrl: z.string().url('Invalid cancel URL'),
})

/** Max ids accepted by a single POST /students/export request. */
export const EXPORT_MAX_STUDENTS = 25

export const studentExportSchema = z.object({
  studentIds: z.array(z.string().uuid()).min(1).max(EXPORT_MAX_STUDENTS),
})
